import { useEffect, useRef, useState } from "react"

import { initialState } from "../../eftpos/paymentScreen"
import { connectPanel } from "../../eftpos/panelActions"

// WDCE-199 step 9g-3b (D56): the EFTPOS panel's session for one order, as React state. connectPanel
// (eftpos/panelActions.js, tested) does the work: not enabled, it does nothing at all (no session, request, listener or
// timer). Enabled, one session per mounted order: the page-load lookup, wake when the tab is visible again, and stop on
// unmount or when the order changes.
export default function useEftposPayment({ enabled, orderId }) {
  const [state, setState] = useState(initialState)
  const [keyBusy, setKeyBusy] = useState(false)
  const [approvedHere, setApprovedHere] = useState(false)
  const connection = useRef(null)

  useEffect(() => {
    const csrfMeta = document.querySelector("meta[name='csrf-token']")
    const connected = connectPanel({
      enabled,
      orderId,
      fetch: window.fetch.bind(window),
      csrfToken: csrfMeta ? csrfMeta.getAttribute("content") : "",
      setTimeout: window.setTimeout.bind(window),
      clearTimeout: window.clearTimeout.bind(window),
      document,
      onState: setState,
      onKeyBusy: setKeyBusy,
      onApprovedHere: () => setApprovedHere(true)
    })
    connection.current = connected

    return () => {
      connected.stop()
      connection.current = null
    }
  }, [enabled, orderId])

  const pay = (args) => connection.current && connection.current.pay(args)
  const pressKey = (key, data) => connection.current && connection.current.pressKey(key, data)

  return { state, keyBusy, approvedHere, pay, pressKey }
}
